import React from "react";
import { NavDropdown } from 'react-bootstrap';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import { IndexPage } from "./pages/IndexPage";
import { PageWelevenClock } from "./pages/PageWelevenClock";
import { PageWelevenStart } from "./pages/PageWelevenStart";
const router = createBrowserRouter([
    {
        path: "/",
        element: React.createElement(IndexPage, null),
    },
    {
        path: "/kde-weleven-start",
        element: React.createElement(PageWelevenStart, null)
    },
    {
        path: "/kde-weleven-clock",
        element: React.createElement(PageWelevenClock, null)
    }
]);
export const Application = () => {
    return React.createElement(React.StrictMode, null,
        React.createElement("div", { className: "flex flex-row m-0 p-3 bg-primary" },
            React.createElement("a", { className: "navbar-brand text-white", href: "/" }, "KDE WELEVEN"),
            React.createElement("div", { className: "container text-white" },
                React.createElement(NavDropdown, { title: "Products" },
                    React.createElement(NavDropdown.Item, { href: "/kde-weleven-start", className: "fs-7" }, "KDE Weleven Start"),
                    React.createElement(NavDropdown.Item, { href: "/kde-weleven-clock", className: "fs-7" }, "KDE Weleven Clock")))),
        React.createElement("div", { className: "container-fluid flex flex-column flex-grow mt-5 p-0" },
            React.createElement("div", { className: "container" },
                React.createElement(RouterProvider, { router: router }))),
        React.createElement("div", { className: "align-self-center p-3" },
            React.createElement("span", { className: "flex justify-content-center" },
                React.createElement("span", { className: "pe-2 x-small text-disabled" },
                    "\u00A9 ",
                    new Date().getFullYear()),
                React.createElement("a", { className: "pe-2 x-small text-decoration-none text-disabled", href: "https://www.kde-weleven.org" }, "KDE WELEVEN"),
                React.createElement("span", { className: "fs-1 middot pe-2 text-disabled" }, "\u00B7"),
                React.createElement("a", { className: "pe-2 x-small text-decoration-none text-disabled", href: "/privacy-policy" }, "Privacy Policy"),
                React.createElement("span", { className: "fs-1 middot pe-2 text-disabled" }, "\u00B7"),
                React.createElement("a", { className: "x-small text-decoration-none text-disabled", href: "/legal-notice" }, "Legal Notice"))));
};
